// Métadonnées partagées du module Maintenance.

export const STATUT_META = {
  nouvelle:  { label: 'Nouvelle' },
  a_traiter: { label: 'À traiter' },
  planifiee: { label: 'Planifiée' },
  en_cours:  { label: 'En cours' },
  terminee:  { label: 'Terminée' },
  refusee:   { label: 'Refusée' },
  annulee:   { label: 'Annulée' },
};

export const STATUT_LIST = ['nouvelle', 'a_traiter', 'planifiee', 'en_cours', 'terminee', 'refusee', 'annulee'];

export const CATEGORIES_PIECE = ['Photo', 'Devis', 'Rapport', 'Autre'];

export const statutLabel = (s) => STATUT_META[s]?.label || s;

export const personName = (o, prefix = '') => {
  const p = o[`${prefix}prenom`];
  const n = o[`${prefix}nom`];
  const full = [p, n].filter(Boolean).join(' ').trim();
  return full || o[`${prefix}username`] || '—';
};

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
